import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "trainingFormsContainer",
    "officeFormsContainer",
    "ptoFormsContainer",
    "unpaidFormsContainer",
    "trainingFormTemplate",
    "officeFormTemplate",
    "ptoFormTemplate",
    "unpaidFormTemplate",
  ];

  addTrainingForm() {
    this.cloneAndAddTemplate(
      this.trainingFormTemplateTarget,
      this.trainingFormsContainerTarget
    );
  }

  addOfficeForm() {
    this.cloneAndAddTemplate(
      this.officeFormTemplateTarget,
      this.officeFormsContainerTarget
    );
  }

  addPTOForm() {
    this.cloneAndAddTemplate(
      this.ptoFormTemplateTarget,
      this.ptoFormsContainerTarget
    );
  }

  addUnpaidForm() {
    this.cloneAndAddTemplate(
      this.unpaidFormTemplateTarget,
      this.unpaidFormsContainerTarget
    );
  }

  cloneAndAddTemplate(template, target) {
    const clone = template.content.cloneNode(true);

    target.appendChild(clone);

    const newForm = target.lastElementChild;
    this.scrollToElement(newForm);
  }

  removeForm(event) {
    const formElement = event.target.closest(
      '[data-sdr-assignments-target="formWrapper"]'
    );
    if (formElement) {
      formElement.remove();
    }
  }

  scrollToElement(element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
}
